import React, { Component } from 'react';
import { Container, Alert } from 'react-bootstrap';
import Title from 'context/title';

export default class Page extends Component {
  componentDidMount() {
    Title.setNotFound();
  }

  render() {
    return (
      <>
        <Container className="blob-header-row header-message-row">
          <Alert variant="warning">Requested page has not been found.</Alert>
        </Container>
      </>
    );
  }
}
